module.exports = __webpack_public_path__ + "img/dgjg2333_2.32df8b55.svg";